var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.271,
    height: 13.771,
    viewBox: "0 0 13.271 13.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2359",
    "data-name": "Trac\\xE9 2359",
    d: "M-2086.174,2135.967h-3.609a.86.86,0,0,0-.125.012.864.864,0,0,0-.124-.012h-3.609a2.905,2.905,0,0,0-2.9,2.9v7.966a2.905,2.905,0,0,0,2.9,2.9h3.609a.9.9,0,0,0,.124-.012.9.9,0,0,0,.125.012h3.609a2.906,2.906,0,0,0,2.9-2.9v-7.966A2.906,2.906,0,0,0-2086.174,2135.967Zm-8.6,10.869v-7.966a1.131,1.131,0,0,1,1.13-1.13h.673a5.1,5.1,0,0,1,3.985,1.913,5.161,5.161,0,0,1,1,4.36,5.237,5.237,0,0,1-5.188,3.953h-.471A1.131,1.131,0,0,1-2094.77,2146.836Zm9.726,0a1.131,1.131,0,0,1-1.13,1.13h-2.23a6.614,6.614,0,0,0,2.154-3.575,6.924,6.924,0,0,0-1.352-5.849,6.935,6.935,0,0,0-.773-.8h2.2a1.131,1.131,0,0,1,1.13,1.13Z",
    transform: "translate(2096.542 -2135.967)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIconBlack);
export default __webpack_public_path__ + "static/media/articleIconBlack.2bdc73e6fa602796ec9fd49b73671ab0.svg";
export { ForwardRef as ReactComponent };